export const CHECK_SVG = 'assets/homepage/choose-digital-business-card/check.svg';
export const ASSETS_SVG = 'assets/svg/';
export const DUMMY_PROFILE_PIC = 'assets/about-us/team-dummy-pic.png'; // todo: remove when we got real data
